// Single source of identity facts reused by the terminal and the extra pages.
// Everything here mirrors what the main site already states (About, Experience,
// Footer) — keep the two in sync when something changes.

export const profile = {
  name: 'Samukelo Mkhonza',
  role: 'Cloud Technologist',
  company: 'CloudZA',
  location: 'Bellville, Western Cape, South Africa',
  email: 'samukelo.mkhonza@outlook.com',
  github: 'Samukelo-Mkhonza',
  githubUrl: 'https://github.com/Samukelo-Mkhonza',
  linkedinUrl: 'https://www.linkedin.com/in/samukelo-mkhonza-a27340215/',
  siteRepo: 'Samukelo-Mkhonza/my-profile-website',
  bio: [
    "I'm a passionate software developer specializing in cloud-native infrastructures and high-performance applications. Currently, I architect solutions at CloudZA, leveraging AWS to build scalable, secure systems that drive business growth.",
    "My journey in technology spans over 5 years, during which I've had the privilege of working with cutting-edge technologies and contributing to projects that make a real difference. I believe in writing clean, maintainable code and creating solutions that not only work but scale beautifully.",
  ],
  interests: ['Coffee Brewing', 'Music Production', 'Gaming', 'Open Source'],
};

export default profile;
